export { default } from './EmptyShelf';



// WEBPACK FOOTER //
// ./app/components/shelves/EmptyShelf/index.js